"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _assign2 = _interopRequireDefault(require("../_helpers/assign"));

var _afterinit = _interopRequireDefault(require("./_afterinit"));

var _mediateitem = _interopRequireDefault(require("./mediateitem"));

var _orderby = _interopRequireDefault(require("./orderby"));

var _pull = _interopRequireDefault(require("./pull"));

var _recreate = _interopRequireDefault(require("./recreate"));

var _rerender = _interopRequireDefault(require("./rerender"));

var _restore = _interopRequireDefault(require("./restore"));

var _tojson = _interopRequireDefault(require("./tojson"));

var _pseudonativemethods = _interopRequireDefault(require("./_pseudonativemethods"));

var _iterator = _interopRequireDefault(require("./iterator"));

var symbolIterator = typeof Symbol === 'function' ? Symbol.iterator : '@@iterator';

var _default = (0, _assign2["default"])((0, _defineProperty2["default"])({
  _afterInit: _afterinit["default"],
  mediateItem: _mediateitem["default"],
  orderBy: _orderby["default"],
  pull: _pull["default"],
  recreate: _recreate["default"],
  rerender: _rerender["default"],
  restore: _restore["default"],
  toJSON: _tojson["default"],
  length: 0,
  isSeempleArray: true
}, symbolIterator, _iterator["default"]), _pseudonativemethods["default"]);

exports["default"] = _default;
//# sourceMappingURL=_prototype.js.map